import { useAppSelector } from '@application/store/useStore';
export function useProjectTaskCount() {
    const assignmentReasons = useAppSelector((state) => state.assignmentReason.AssignmentReasons);
    return assignmentReasons?.length ?? 0;
}
